import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["listRef", "listTotal", "name", "itemsPerPage", "isInfinite", "limitToUse", "paginationType", "currentPage"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Classic from './Classic';
import LoadMore from './LoadMore';
import { LOAD_MORE } from '../../../../constants';
const ListPagination = _ref => {
  let {
      listRef,
      listTotal,
      name,
      itemsPerPage,
      isInfinite,
      limitToUse,
      paginationType,
      currentPage
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [showPagination, setShowPagination] = useState(true);
  const isLoadMore = paginationType === LOAD_MORE;
  const scrollOnClick = () => {
    if (!isLoadMore && listRef && listRef.current) {
      listRef.current.scrollIntoView();
    }
  };
  useEffect(() => {
    if (isInfinite) setShowPagination(false);
  }, [isInfinite]);
  if (!showPagination) return null;
  const totalRecordsToFetch = limitToUse || listTotal;
  const numberOfPages = Math.ceil(totalRecordsToFetch / itemsPerPage);
  const isLastPage = currentPage >= numberOfPages;
  if (numberOfPages <= 1 || isLastPage && isInfinite) return null;
  const paginationProps = _objectSpread({
    name,
    numberOfPages,
    currentPage,
    isLastPage,
    onClick: scrollOnClick
  }, props);
  return /*#__PURE__*/React.createElement("div", {
    className: "pagination"
  }, isLoadMore ? /*#__PURE__*/React.createElement(LoadMore, paginationProps) : /*#__PURE__*/React.createElement(Classic, paginationProps));
};
ListPagination.propTypes = {
  listRef: PropTypes.object.isRequired,
  currentPage: PropTypes.number.isRequired,
  paginationType: PropTypes.string.isRequired,
  listTotal: PropTypes.number.isRequired,
  isInfinite: PropTypes.bool.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  limitToUse: PropTypes.number
};
ListPagination.defaultProps = {
  limitToUse: null
};
export default ListPagination;
//# sourceMappingURL=ListPagination.js.map